import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  VACATION_PUBLIC_INFO,
  VACATION_REQUEST_DOWNLOAD,
  VACATION_REQUEST_LIST,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const VACATION = GLOBAL_STATE

export const { reducer: vacationReducer } = createSlice({
  name: VACATION,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.vacationList.pending, state => {
        state[VACATION_REQUEST_LIST].loading = true
      })
      .addCase(actionCreators.vacationList.rejected, (state, action) => {
        state[VACATION_REQUEST_LIST].loading = false
        state[VACATION_REQUEST_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.vacationList.fulfilled, (state, action) => {
        state[VACATION_REQUEST_LIST].loading = false
        state[VACATION_REQUEST_LIST].error = null
        state[VACATION_REQUEST_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.vacationDownload.pending, state => {
        state[VACATION_REQUEST_DOWNLOAD].loading = true
      })
      .addCase(actionCreators.vacationDownload.rejected, (state, action) => {
        state[VACATION_REQUEST_DOWNLOAD].loading = false
        state[VACATION_REQUEST_DOWNLOAD].error = action.payload as AxiosError
      })
      .addCase(actionCreators.vacationDownload.fulfilled, (state, action) => {
        state[VACATION_REQUEST_DOWNLOAD].loading = false
        state[VACATION_REQUEST_DOWNLOAD].error = null
        state[VACATION_REQUEST_DOWNLOAD].data = action.payload
      })

    builder
      .addCase(actionCreators.vacationPublicInfo.pending, state => {
        state[VACATION_PUBLIC_INFO].loading = true
      })
      .addCase(actionCreators.vacationPublicInfo.rejected, (state, action) => {
        state[VACATION_PUBLIC_INFO].loading = false
        state[VACATION_PUBLIC_INFO].error = action.payload as AxiosError
      })
      .addCase(actionCreators.vacationPublicInfo.fulfilled, (state, action) => {
        state[VACATION_PUBLIC_INFO].loading = false
        state[VACATION_PUBLIC_INFO].error = null
        state[VACATION_PUBLIC_INFO].data = action.payload
      })

    builder.addCase(actionCreators.vacationListClear, state => {
      state[VACATION_REQUEST_LIST] = defaultState()
    })

    builder.addCase(actionCreators.vacationDownloadClear, state => {
      state[VACATION_REQUEST_DOWNLOAD] = defaultState()
    })

    builder.addCase(actionCreators.vacationPublicInfoClear, state => {
      state[VACATION_PUBLIC_INFO] = defaultState()
    })
  },
})
